import React, { useState } from 'react';
import { api } from '../services/api';

export default function BootstrapSuperAdmin() {
  const [bootstrapCode, setBootstrapCode] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setResult(null);

    try {
      const payload = {
        bootstrap_code: bootstrapCode,
        email,
      };
      if (password) payload.password = password;
      if (fullName) payload.full_name = fullName;

      const r = await api.bootstrapSuperAdmin(payload);
      setResult(r);
    } catch (err) {
      setError(err.message || 'Bootstrap failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Bootstrap Super Admin</h1>
        <p style={styles.subtitle}>
          This page is intentionally hidden. It only works when the backend is started with a valid{' '}
          <code>SUPER_ADMIN_BOOTSTRAP_CODE</code> and there is no existing <code>super_admin</code>.
        </p>

        {error && <div style={styles.error}>{error}</div>}
        {result && (
          <div style={styles.success}>
            <div><b>Success.</b></div>
            <div>Email: {result.email}</div>
            <div>Role: {result.role}</div>
            <div>{result.created ? 'User created' : 'User promoted'}</div>
            <div style={{ marginTop: 12 }}>
              Next: remove <code>SUPER_ADMIN_BOOTSTRAP_CODE</code> from the backend environment and redeploy.
            </div>
          </div>
        )}

        <form onSubmit={onSubmit} style={styles.form}>
          <label style={styles.label}>
            Bootstrap code
            <input
              type="password"
              value={bootstrapCode}
              onChange={(e) => setBootstrapCode(e.target.value)}
              style={styles.input}
              required
              autoFocus
            />
          </label>

          <label style={styles.label}>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
          </label>

          <label style={styles.label}>
            Full name (optional)
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              style={styles.input}
              placeholder="e.g. Mike Thomas"
            />
          </label>

          <label style={styles.label}>
            Password (required if creating a new user)
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="Leave blank to promote an existing user"
            />
          </label>

          <button type="submit" style={styles.button} disabled={isLoading}>
            {isLoading ? 'Working…' : 'Create / Promote Super Admin'}
          </button>
        </form>

        <div style={styles.footer}>
          Tip: after success, log in normally to refresh your JWT (role is embedded in the token).
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0f172a',
    padding: 16,
    color: '#f1f5f9',
  },
  card: {
    width: '100%',
    maxWidth: 520,
    background: '#1e293b',
    border: '1px solid #334155',
    borderRadius: 12,
    padding: 24,
  },
  title: {
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
  },
  subtitle: {
    marginTop: 8,
    marginBottom: 16,
    fontSize: 13,
    color: '#94a3b8',
    lineHeight: 1.4,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    fontSize: 13,
    color: '#cbd5e1',
  },
  input: {
    padding: '12px 14px',
    fontSize: 14,
    border: '1px solid #334155',
    borderRadius: 8,
    outline: 'none',
    background: '#0f172a',
    color: '#f1f5f9',
  },
  button: {
    marginTop: 8,
    padding: '12px 14px',
    fontSize: 14,
    fontWeight: 600,
    background: 'var(--brand-primary, #3b82f6)',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
  },
  error: {
    background: 'rgba(239, 68, 68, 0.2)',
    color: '#fca5a5',
    padding: 12,
    borderRadius: 8,
    marginBottom: 12,
    fontSize: 13,
  },
  success: {
    background: 'rgba(34, 197, 94, 0.15)',
    color: '#bbf7d0',
    padding: 12,
    borderRadius: 8,
    marginBottom: 12,
    fontSize: 13,
    lineHeight: 1.4,
  },
  footer: {
    marginTop: 16,
    fontSize: 12,
    color: '#94a3b8',
  },
};
